import { ViewRef, Directive, Input, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[view]'
})
export class ViewDirective {
  constructor(private vcRef: ViewContainerRef) {}

  @Input()
  set view(view: ViewRef) {
    if (view) {
      this.vcRef.clear();
      this.vcRef.insert(view);
    }
  }

  OnDestroy(): void {
    this.vcRef.clear();
  }
}
